



import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Eye, EyeOff } from "lucide-react"; // Added for password visibility

import APIConfig from "../Common/Configurations/APIConfig";
import Auth from "../Common/Configurations/Auth";
import PublicHeader from "../Navigation/PublicHeader";

function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState(""); // This holds Email or Phone
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        APIConfig.APIACTIVEURL + APIConfig.LOGIN,
        {
          email, // Backend logic handles Email or Phone automatically
          password,
        }
      );

      const { token, roles, fullName, permissions } = response.data;
      const role = roles && roles.length > 0 ? roles[0] : "Staff";

      // 1. Save to Auth helper
      // Auth.login(response.data);
      Auth.login({ ...response.data, permissions }); 

      // 2. Explicitly save Role and Name
      localStorage.setItem("userRole", role); 
      localStorage.setItem("userName", fullName);
      localStorage.setItem("userPermissions", JSON.stringify(permissions || []));

      Swal.fire({
        icon: 'success',
        title: 'Login Successful',
        text: `Welcome back, ${fullName}`,
        timer: 1500,
        showConfirmButton: false
      });

      navigate("/dashboard");
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: 'Login Failed',
        text: error.response?.data?.message || "Invalid credentials",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PublicHeader />

      <div style={{ minHeight: "calc(100vh - 70px)", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#f4f7fb", fontFamily: "'Inter', sans-serif" }}>
        <div style={{ width: "400px", backgroundColor: "#fff", padding: "40px", borderRadius: "20px", boxShadow: "0 10px 25px rgba(0,0,0,0.05)" }}>
          <div style={{ textAlign: 'center', marginBottom: '30px' }}>
             <h2 style={{ fontSize: '28px', fontWeight: '800', color: '#1b2559', margin: '0' }}>Welcome Back</h2>
             <p style={{ color: '#a3aed0', marginTop: '8px', fontSize: '14px' }}>Sign in with your Email or Phone Number</p>
          </div>

          <form onSubmit={handleLogin}>
            <div style={{ marginBottom: "20px" }}>
              <label style={{ fontSize: '14px', fontWeight: '700', color: '#1b2559', marginLeft: '4px' }}>Login Identity</label>
              <input
                type="text" // CHANGED FROM EMAIL TO TEXT
                placeholder="Email or Phone Number"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ width: "100%", padding: "14px", marginTop: "8px", border: "1.5px solid #e2e8f0", borderRadius: "12px", outline: 'none', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>

            <div style={{ marginBottom: "30px" }}>
              <label style={{ fontSize: '14px', fontWeight: '700', color: '#1b2559', marginLeft: '4px' }}>Password</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{ width: "100%", padding: "14px", marginTop: "8px", border: "1.5px solid #e2e8f0", borderRadius: "12px", outline: 'none', fontSize: '14px', boxSizing: 'border-box' }}
                />
                <button 
                  type="button" 
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ position: 'absolute', right: '12px', top: '22px', background: 'none', border: 'none', cursor: 'pointer', color: '#a3aed0' }}
                >
                  {showPassword ? <EyeOff size={18}/> : <Eye size={18}/>}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{ width: "100%", padding: "14px", backgroundColor: "#4f46e5", color: "#fff", border: "none", borderRadius: "12px", fontSize: "16px", fontWeight: "700", cursor: loading ? "not-allowed" : "pointer", boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)" }}
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
          
          <div style={{ textAlign: 'center', marginTop: '25px' }}>
            <p style={{ fontSize: '13px', color: '#a3aed0' }}>Secure Real Estate Management System</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;